<app-element-for-each-codelist-item [model]="model" [isVisible]="isVisible" [isRequired]="true" [alwaysExpanded]="true">
</app-element-for-each-codelist-item>
